/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** 用户需要鉴权操作的接口 */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** 用户需要鉴权操作的接口 退出登录 */
export async function logoutPost(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultstring>({
    url: `/auth/api/biz/user/logout`,
    method: 'post',
    ...options,
  });

  return result.data;
}

/** 用户需要鉴权操作的接口 修改密码 */
export async function changePasswordPost(payload: model.IApiChangePasswordReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/auth/api/biz/user/password/change`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}
